import { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import { HiEye, HiOutlinePlusSm } from "react-icons/hi";
import { RiDeleteBinLine } from "react-icons/ri";
import { BiDownload, BiLoader } from "react-icons/bi";
import { FiEye } from "react-icons/fi";
import { useMsal } from "@azure/msal-react";
import Table from "../table/table";
import { Tooltip } from "primereact/tooltip";
import "./fileUpload.css";
import DeleteConfirmation from "../modal/deleteConfirmation/deleteConfirmation";
import { getRequest } from "../../actions/Handler";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import FileViewer from "../modal/fileViewer/fileViewer";

export default function FileUpload(props: any) {
  const [inputFile, setInputFile] = useState<HTMLInputElement | null>(null);
  const [showDownloadLoader, setDownloadLoader] = useState(false);

  interface FileRowProps {
    attachmentId: string;
    attachment: any;
    attachmentName: String;
    attachmentUrl: String;
    attachmentSize: String;
    modifiedBy: String;
    modifiedDate: String;
    analysis: String;
  }
  const [fileRow, setFileRow] = useState<FileRowProps[]>([]);
  const [state] = useState({
    userDetail: useMsal().accounts,
  });

  const loggedInUser: any = state.userDetail[0].username;
  const [deletePopup, setDeletePopup] = useState({
    showPopup: false,
    popupMessage: "",
    popupType: "",
    data: null,
    confirm: false,
  });

  let userDetail = JSON.parse(
    sessionStorage.getItem("userDetail") || "{}"
  ) as any;

  let isCentralUser: boolean = false;
 
  if (userDetail.role === "Central User") {
    isCentralUser = true;
  }

  useEffect(() => {
    setInputFile(document.getElementById("input-file") as HTMLInputElement);
  }, []);
  useEffect(() => {
    if (props.readOnly || props.type) {
      const updatedRowdata = props.data.map((val: any) => {
        val.modifiedDate = formatDate(val.modifiedDate);
        return val;
      });
      //setFileRow(props.data);
      setFileRow(updatedRowdata);
    }
  }, [props.data]);
  useEffect(() => {
    setInputFile(document.getElementById("input-file") as HTMLInputElement);
  }, [props.readOnly]);

  useEffect(() => {
    if (deletePopup.confirm) {
      switch (deletePopup.popupType) {
        case "fileUpload":
          deleteUpload(deletePopup.data);
      }
    }
  }, [deletePopup]);

  const deletePopupChange = (data: any, type: any) => {
    setDeletePopup({
      showPopup: true,
      popupMessage: "Are you sure you want to delete this item?",
      popupType: type,
      data: data,
      confirm: false,
    });
  };

  const cancelDelete = () => {
    setDeletePopup({
      showPopup: false,
      popupMessage: "",
      popupType: "",
      data: null,
      confirm: false,
    });
  };

  const confirmDelete = () => {
    var deleteData = { ...deletePopup };
    deleteData["confirm"] = true;
    deleteData["showPopup"] = false;
    setDeletePopup(deleteData);
  };

  const handleUpload = (e: any) => {
    e.preventDefault();
    inputFile?.click();
  };

  const preventDefault = (e: any) => {
    e.preventDefault();
  };

  const deleteUpload = (rowData: any) => {
    var arr = [...fileRow] as any;
    const requiredIndex = arr.findIndex((el: any) => {
      return el.attachmentId === rowData.attachmentId;
    });
    if (requiredIndex === -1) {
      return false;
    }
    if (props.type === "1") {
      props.setDeleteFileUpload(rowData.blobId);
    } else {
      arr.splice(requiredIndex, 1);
      setFileRow(arr);
      props.handler(arr);
    }
  };

  const onFileChange = async (e: any) => {
    if (
      e.target.files[0].name.match(
        /.(xlsx|xls|txt|pdf|jpeg|jpg|png|ppt|pptx|doc|docx|csv|heic|heif)$/i
      )
    ) {
      if (e.target.files[0].size / 1024 / 1024 > 40) {
        toast("The selected file should be less than 40MB!", {
          type: "error",
          autoClose: 3000,
          pauseOnHover: true,
          delay: 0,
        });
        return false;
      }
      // restrict empty files
      const size = e.target.files[0].size
      if (size == 0) {
        toast("Empty Files are not allowed!", {
          type: "error",
          autoClose: 3000,
          pauseOnHover: true,
          delay: 0,
        });
        return false;
      }

      var fileDetail = {
        fileName: e.target.files[0].name,
        fileType: e.target.files[0].type,
        fileUrl: URL.createObjectURL(e.target.files[0]),
        fileSize: bytesToSize(e.target.files[0].size),
        fileSelected: true,
      };
      const date = new Date();
      const yyyy = date.getFullYear();
      let mm = (date.getMonth() + 1).toString(); // Months start at 0!
      let dd = date.getDate().toString();

      if (+dd < 10) dd = "0" + dd;
      if (+mm < 10) mm = "0" + mm;

      const today = mm + "/" + dd + "/" + yyyy;

      const unique_id = uuid();
      var id = unique_id.slice(0, 8);
      if (props.type === "1") {
        props.handler({
          attachmentId: id,
          attachment: await genereateBase64(e.target.files[0]),
          attachmentName: fileDetail.fileName,
          attachmentUrl: fileDetail.fileUrl,
          attachmentSize: fileDetail.fileSize,
          modifiedBy: loggedInUser,
          modifiedDate: today,
          analysis: props.fileCategory,
        });
      } else {
        setFileRow([
          ...fileRow,
          {
            attachmentId: id,
            attachment: await genereateBase64(e.target.files[0]),
            attachmentName: fileDetail.fileName,
            attachmentUrl: fileDetail.fileUrl,
            attachmentSize: fileDetail.fileSize,
            modifiedBy: loggedInUser,
            modifiedDate: today,
            analysis: props.fileCategory,
          },
        ]);
        props.handler([
          ...fileRow,
          {
            attachmentId: id,
            attachment: await genereateBase64(e.target.files[0]),
            attachmentName: fileDetail.fileName,
            attachmentUrl: fileDetail.fileUrl,
            attachmentSize: fileDetail.fileSize,
            modifiedBy: loggedInUser,
            modifiedDate: today,
            analysis: props.fileCategory,
          },
        ]);
      }
    } else {
      // not supported file format
      errormess();
    }
  };

  const errormess = () => {
    toast("The selected file extension is not supported!", {
      type: "error",
      autoClose: 3000,
      pauseOnHover: true,
      delay: 0,
    });
  };

  const genereateBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        return resolve(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    });
  };

  const bytesToSize = (bytes: any) => {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"] as any;
    if (bytes === 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)) as any);
    return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
  };

  const downloadSelectedFile = (
    eventReportId: number,
    blobId: any,
    encodingType: any,
    filename: any,
    attachment: any
  ) => {
    if (blobId == "undefined" || blobId == null) {
      const downloadUrl = attachment;
      const downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.innerHTML = "Download File";
      downloadLink.href = downloadUrl;
      downloadLink.click();
      setDownloadLoader(false);
    }
    else {
      return new Promise((resolve) => {
        getRequest({
          url: `api/EventReport/DownloadAttachment?eventReportId=${+eventReportId}&blobId=${blobId}`,
        })
          .then((res) => {
            // return resolve(res);
            const downloadUrl = encodingType + res;
            const downloadLink = document.createElement("a");
            downloadLink.download = filename;
            downloadLink.innerHTML = "Download File";
            downloadLink.href = downloadUrl;
            downloadLink.click();
            setDownloadLoader(false);
          })
          .catch((e) => {
            console.log(e);
            return resolve("");
          });
      });
    }

  };

  const getFileExtension = (filename:any) => {
    const parts = filename.split('.');
    if (parts.length === 1) {
      return ''; // No extension found
    }
    return parts.pop();
  };

  const [showFileModal, setShowFileModal] = useState(false);
  const[file,setFile]=useState();
  const[fileExtension,setFileExtension]=useState();
  const handleFileShow = () => setShowFileModal(true);
  const handleFileClose = () => setShowFileModal(false);


  const viewSelectedFile = (
    eventReportId: number,
    blobId: any,
    encodingType: any,
    filename: any,
    attachment: any
  ) => {
    console.log('in')
    var authorisedExtensions = [ "pdf","jpeg", "jpg", "png",".heic", "heif"];
    var fileExt=getFileExtension(filename)
    if(!authorisedExtensions.includes(fileExt)){
      toast("These types of attachments cannot be viewed", {
        type: "error",
        autoClose: 3000,
        pauseOnHover: true,
        delay: 0,
      });
      setDownloadLoader(false);
      return;
    }
    if (blobId == "undefined" || blobId == null) {
      const downloadUrl = attachment;
      const downloadLink = document.createElement("a");
      downloadLink.target = "_blank";
      downloadLink.innerHTML = "Download File";
      downloadLink.href = downloadUrl;
      downloadLink.click();
      setDownloadLoader(false);
    }
    else {
      return new Promise((resolve) => {
        getRequest({
          url: `api/EventReport/DownloadAttachment?eventReportId=${+eventReportId}&blobId=${blobId}`,
        })
          .then((res) => {
          
            const downloadUrl = encodingType + res;
            setDownloadLoader(false);
            handleFileShow();
            setFile(downloadUrl);
            setFileExtension(fileExt);
          })
          .catch((e) => {
            console.log(e);
            return resolve("");
          });
      });
    }

  };

  const formatDate = (dos: any) => {
    const date = new Date(dos);
    const yyyy = date.getFullYear();
    let mm = (date.getMonth() + 1).toString(); // Months start at 0!
    let dd = date.getDate().toString();

    if (+dd < 10) dd = "0" + dd;
    if (+mm < 10) mm = "0" + mm;

    return mm + "/" + dd + "/" + yyyy;
  };
  let columns = [];
  if (props.type === "1") {

    columns = [
      {
        header: "Actions",
        filter: false,
        body: (rowData: any) => (
          <>
            <div style={{ width: "95px" }}>
              <button
                className="buttonCss me-2 deleteclass buttonIcon"
                disabled={
                  props.readOnly ||
                  props.deletedFileAttachments.includes(rowData.blobId)
                }
                onClick={(event) => {
                  preventDefault(event);
                  deletePopupChange(rowData, "fileUpload");
                }}
              >
                {(() => {
                  if (props.deletedFileAttachments.includes(rowData.blobId)) {
                    return (
                      <BiLoader
                        className="chooseIcon rotate"
                        style={{ fontSize: "14px" }}
                      />
                    );
                  } else {
                    return (
                      <RiDeleteBinLine
                        className="chooseIcon"
                        style={{ fontSize: "14px" }}
                      />
                    );
                  }
                })()}
              </button>
              
              <a
                //href={rowData.attachmentUrl}
                className="buttonCss me-2 downloadIcon"
                
                rel="noreferrer"
                onClick={(event) => {
                  preventDefault(event);
                  setDownloadLoader(true);
                  viewSelectedFile(
                    props.eventReportId,
                    rowData.blobId,
                    rowData.encodingType,
                    rowData.attachmentName,
                    rowData.attachment
                  );
                }}
              >
                <HiEye style={{ fontSize: "14px" }} />
              </a>
              {isCentralUser && <a
                //href={rowData.attachmentUrl}
                className="buttonCss downloadIcon"
                download
                rel="noreferrer"
                onClick={(event) => {
                  preventDefault(event);
                  setDownloadLoader(true);
                  downloadSelectedFile(
                    props.eventReportId,
                    rowData.blobId,
                    rowData.encodingType,
                    rowData.attachmentName,
                    rowData.attachment
                  );
                }}
              >
                <BiDownload style={{ fontSize: "14px" }} />
              </a>}
              
            </div>
          </>
        ),
      },
    ];
  } else {
    columns = [
      {
        header: "Actions",
        filter: false,
        body: (rowData: any) => (
          <>
            <div style={{ width: "95px" }}>
              <button
                className="buttonCss me-2 deleteclass buttonIcon"
                disabled={props.readOnly}
                onClick={(event) => {
                  preventDefault(event);
                  deletePopupChange(rowData, "fileUpload");
                }}
              >
                <RiDeleteBinLine
                  className="chooseIcon"
                  style={{ fontSize: "14px" }}
                />
              </button>

              <a
                //href={rowData.attachmentUrl}
                className="buttonCss downloadIcon"
                download
                rel="noreferrer"
                onClick={(event) => {
                  preventDefault(event);
                  setDownloadLoader(true);
                  downloadSelectedFile(
                    props.eventReportId,
                    rowData.blobId,
                    rowData.encodingType,
                    rowData.attachmentName,
                    rowData.attachment
                  );
                }}
              >
                <BiDownload style={{ fontSize: "14px" }} />
              </a>
              
            </div>
          </>
        ),
        
      },
    ];
  }
  columns = [
    ...columns,
    {
      header: "File Name",
      filter: props.type === "1" ? true : false,
      filterType: props.type === "1" ? "text" : null,
      filterElement: props.type === "1" ? "filterTextTemplate" : null,
      width: "50%",
      field: "attachmentName",
      body: (rowData: any) => (
        <>
          <Tooltip target=".fileNameTooltip"></Tooltip>
          <span
            className="fileNameTooltip"
            data-pr-position="bottom"
            data-pr-tooltip={rowData.attachmentName}
          >
            {rowData.attachmentName?.length > 90
              ? rowData.attachmentName?.slice(0, 89) + "..."
              : rowData.attachmentName}
          </span>
        </>
      ),
    },
    {
      header: "Modified By",
      filter: props.type === "1" ? true : false,
      filterType: props.type === "1" ? "text" : null,
      filterElement: props.type === "1" ? "filterTextTemplate" : null,
      field: "modifiedBy",
      body: (rowData: any) => (
        <>
          <Tooltip target=".modifiedby" className="toolTip"></Tooltip>
          <span
            className="modifiedby"
            data-pr-position="bottom"
            data-pr-tooltip={rowData.modifiedBy}
          >
            {rowData.modifiedBy.length > 35
              ? rowData.modifiedBy.slice(0, 34) + "..."
              : rowData.modifiedBy}
          </span>
        </>
      ),
    },
    {
      header: "Modified Date",
      filter: props.type === "1" ? true : false,
      filterType: props.type === "1" ? "text" : null,
      filterElement: props.type === "1" ? "filterTextTemplate" : null,
      field: "modifiedDate",
    },
    {
      header: "Type",
      filter: props.type === "1" ? true : false,
      filterType: props.type === "1" ? "text" : null,
      filterElement: props.type === "1" ? "filterTextTemplate" : null,
      field: "analysis",
    },
  ];

  return (
    <>
      <Col md="12" sm="12" xs="12" className="pt-3">
        {(() => {
          if (!props.readOnly) {
            return (
              <>
                <label
                  style={{
                    color: "#495057",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  Add New File
                </label>
                <div className="mt-1 mb-2">
                  <input
                    id="input-file"
                    className="d-none"
                    type="file"
                    onChange={onFileChange}
                    onClick={(event: any) => {
                      event.target.value = null;
                    }}
                    accept=".xlsx, .xls, .txt, .pdf, .jpeg, .jpg, .png, .ppt, .pptx, .doc, .docx, .csv, .heic, .heif"
                  />
                  {(() => {
                    if (props.type === "1") {
                      if (props.fileAttachment !== null) {
                        return (
                          <button className="buttonCss" disabled>
                            <BiLoader className="chooseIcon rotate" /> Choose
                          </button>
                        );
                      } else {
                        return (
                          <button
                            onClick={handleUpload}
                            className="buttonCss"
                            disabled={props.fileCategory ? false : true}
                          >
                            <HiOutlinePlusSm className="chooseIcon" /> Choose
                          </button>
                        );
                      }
                    } else {
                      return (
                        <button
                          onClick={handleUpload}
                          className="buttonCss"
                          disabled={props.fileCategory ? false : true}
                        >
                          <HiOutlinePlusSm className="chooseIcon" /> Choose
                        </button>
                      );
                    }
                  })()}
                </div>
              </>
            );
          } else {
            return <></>;
          }
        })()}
        {showDownloadLoader ? (
          <>
            <div id="q11">
              <div className="loading">
                <div className="obj"></div>
              </div>
            </div>{" "}
          </>
        ) : null}
        <div className="mb-3">
          <Table
            column={columns}
            rows={fileRow}
            lazy={false}
            screen="fileUpload"
            pagination={false}
            defaultFilter={true}
          ></Table>
        </div>
      </Col>
      <DeleteConfirmation
        deletePopup={deletePopup}
        cancelDelete={cancelDelete}
        confirmDelete={confirmDelete}
      />
      <FileViewer show={showFileModal} onHide={handleFileClose} base64={file} fileExt={fileExtension} />
    </>
  );

  

}

